import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Certificado } from '../models/certificado.model';

export interface SolicitudCertificado {
  certificado: number;
  cliente: number;
  centro: number;
  recogidas: string[];
}

export interface ValidacionResiduoCertificado {
  codigoLer: string;
  descripcion: string;
  tratamiento: string;
  autorizacion: string;
}

export interface ValidacionCertificado {
  csv: string;
  cliente: string;
  clienteCif: string;
  clienteNima: string;
  certificado: string;
  fechaEmision: string;
  residuos: ValidacionResiduoCertificado[];
}

export interface EstadoSolicitudCertificado {
  solicitud: number;
  estado: string;
  mensaje: string;
}

@Injectable({ providedIn: 'root' })
export class CertificadosService {
  constructor(private http: HttpClient) { }

  public searchByCentro$(cpdcod: number, cliente: number): Observable<Certificado[]> {
    const params = new HttpParams().set('cpdcod', String(cpdcod)).set('cliente', String(cliente));
    return this.http.get<Certificado[]>(this.url('certificados'), { params });
  }

  public disponibles$(): Observable<boolean> {
    return this.http.get<boolean>(this.url('certificados/disponibles'));
  }

  public soloClienteDemo$(): Observable<boolean> {
    return this.http.get<boolean>(this.url('certificados/solo-cliente-demo'));
  }

  public lineasSolicitadas$(cliente: number, recogidas: string[]): Observable<string[]> {
    return this.http.post<string[]>(this.url('certificados/lineas/solicitadas'), { cliente, recogidas });
  }

  public lineasSolicitadasPorLotes$(cliente: number, recogidas: string[]): Observable<string[]> {
    const tamanyoLote = 100;
    const lotes: string[][] = [];
    for (let indice = 0; indice < recogidas.length; indice += tamanyoLote) {
      lotes.push(recogidas.slice(indice, indice + tamanyoLote));
    }
    if (lotes.length === 0) {
      return of([]);
    }
    return forkJoin(lotes.map(lote => this.lineasSolicitadas$(cliente, lote))).pipe(
      map(resultados => ([] as string[]).concat(...resultados))
    );
  }

  public validar$(token: string): Observable<ValidacionCertificado> {
    return this.http.post<ValidacionCertificado>(this.urlValidacionPublica(), { token });
  }

  private urlValidacionPublica(): string {
    const api = new URL(environment.HOST);
    if (!environment.production && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
      api.hostname = window.location.hostname;
    }
    return api.origin + environment.RECOGIDAS_API + 'certificados/verificar';
  }

  public emitir$(solicitud: SolicitudCertificado): Observable<EstadoSolicitudCertificado> {
    return this.http.post<EstadoSolicitudCertificado>(this.url('certificados/emisiones'), solicitud);
  }

  private url(ruta: string): string {
    return environment.HOST + environment.RECOGIDAS_API + ruta;
  }
}
